module.exports = __webpack_public_path__ + "img/dowload.c5ef8e98.svg";